import React, { PureComponent } from "react";

import LinkedImage from "@fdmg/ts-react-linked-image";
import styled from "styled-components";

import Player from "./Player";
import Playlist from "./Playlist";

export interface Props {
  isCustomPlaylist?: boolean;
  websiteUrl: string;
  podcastTitle: string;
  branded?: boolean;
  episodes?: any;
  artworkUrl: string;
  sponsors: any;
  maxVisibleItems?: number;
  programType: any;
  customColors?: any;
  hidePodcastTitle?: any;
  hideEpisodeTitle?: any;
  episodeTitle?: any;
  playlistIndex?: boolean;
  handleProgramIndexChange?: (...args: any[]) => void;
  handleCustomPlaylistIndexChange?: (...args: any[]) => void;
}
/**
 * AudioWidget player composition - Renders all the audioplayer's components.
 */
export default class AudioPlayerComposition extends PureComponent<Props, any> {
  constructor(props: Props) {
    super(props);
    this.state = {
      programIndex: 0
    };
  }

  /**
   * The Player parent component is the only thing allowed
   * to change the programIndex.
   */
  handleProgramIndexChange = index => {
    this.setState({ programIndex: index });
    if (this.props.handleCustomPlaylistIndexChange) {
      this.props.handleCustomPlaylistIndexChange(index);
    }
  };

  /**
   * Unless specified in the url, the 'maximum visible items default
   * value' (before a user has to scroll) is set to 5. If there are
   * less items than the default value, it should take the maximum items.
   */
  determineMaxVisibleItems = () => {
    if (this.props.maxVisibleItems) {
      return this.props.maxVisibleItems;
    } else if (this.props.episodes.length < 5) {
      return this.props.episodes.length;
    }

    return 5;
  };

  render() {
    const maxVisibleItems = this.determineMaxVisibleItems();
    return (
      <AudioPlayer
        className="audio-player"
        customColors={
          this.props.customColors.length > 0 ? this.props.customColors : []
        }
      >
        <Player
          isCustomPlaylist={this.props.isCustomPlaylist}
          podcastTitle={this.props.podcastTitle}
          websiteUrl={this.props.websiteUrl}
          artworkUrl={this.props.artworkUrl}
          sponsors={this.props.sponsors}
          episodes={this.props.episodes}
          episodeTitle={this.props.episodeTitle}
          programIndex={this.state.programIndex}
          handleProgramIndexChange={this.handleProgramIndexChange}
          programType={this.props.programType ? this.props.programType : null}
          customColors={
            this.props.customColors.length > 0 ? this.props.customColors : []
          }
          hidePodcastTitle={this.props.hidePodcastTitle}
          hideEpisodeTitle={this.props.hideEpisodeTitle}
          playlistIndex={this.props.playlistIndex}
        />

        {this.props.branded ? null : (
          <LinkedImage
            className="logo"
            src={"./img/logo.svg"}
            alt="BNR"
            href={"https://www.bnr.nl"}
            target="_blank"
          />
        )}

        {this.props.episodes.length <= 1 ? null : (
          <Playlist
            episodes={this.props.episodes}
            currentEpisode={this.state.programIndex}
            selectPlaylistItem={this.handleProgramIndexChange}
            maxVisibleItems={maxVisibleItems}
            customColors={
              this.props.customColors.length > 0 ? this.props.customColors : []
            }
          />
        )}
      </AudioPlayer>
    );
  }
}

const AudioPlayer: any = styled.div`
  position: relative;
  font-size: 16px;
  background-size: cover;
  height: 100%;
  border: 1px solid
    ${(props: any) =>
      props.customColors.length > 0 ? props.customColors[6] : "transparent"};
  box-sizing: border-box;
  .audio {
    margin-top: -5px;
    flex: 8;
  }
  .logo {
    width: 25px;
    height: 30px;
    position: absolute;
    right: 0;
    top: 0;
    padding: 8px 5px 0px 5px;
    img {
      width: 25px;
      height: 22px;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .background-wrapper {
    .player-background {
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      background-size: cover;
      z-index: -1;
    }
  }
`;
